<template>
	<div class="answers_block" >
		<div class="button_add mb-4">
			<button class="btn btn-md btn-block btn-outline-info waves-effect waves-themed" v-on:click="add_answer()">
				<span class="fal  fa-eject mr-1"></span>
				Додати
			</button>
		</div>

		<div class="inf answers">
			<b-overlay :show="is_load" rounded="sm">
				<div v-if="answers.length > 0">
					<ul style="list-style: none" class="pl-0">
						<li class="mt-2 list-style-none p-4 card" v-for="(item,idx) in answers">
							<div class="form-group">
								<div class="input-group">
									<input type="text" v-model="item.title" class="form-control">
									<div class="input-group-append">
										<button type="button" class="btn btn-outline-info waves-effect waves-themed" v-on:click="add_template(item)">+ шаблон </button>
										<button type="button" class="btn btn-outline-danger " v-on:click="remove_answer(idx)">Видалити</button>
									</div>
								</div>
							</div>

							<ul v-if="item.templates.length > 0" style="list-style: none" class="pl-2">
								<li class="mt-2 list-style-none" v-for="(template,idx2) in item.templates">
									<div class="form-group">
										<div class="input-group">
											<input type="text" v-model="template.title" :key="'ttl_' + idx2 + idx" class="form-control">

											<div class="input-group-append">
												<div class="input-group-text">
													<div class="custom-control d-flex custom-switch">
														<input :id="'eventlog-switch-' + idx2 + idx " v-model="template.com_req" type="checkbox" class="custom-control-input">
														<label class="custom-control-label fw-500" :for="'eventlog-switch-' + idx2  + idx">
															Коментар *
														</label>
													</div>
												</div>

												<button type="button" class="btn btn-outline-danger " v-on:click="remove_template(item,idx2)">Видалити</button>
											</div>
										</div>
									</div>
								</li>
							</ul>

						</li>
					</ul>
				</div>
			</b-overlay>
		</div>
	</div>
</template>

<script>
export default {
	name: "checklist_answers",
	props : {
		question : {
			type : Object
		}
	},

	data () {
		return {
			is_load : false,
		}
	},

	methods : {
		add_answer() {
			this.answers.push({
				"id" : 0,
				"title" : "",
				"templates" : [],
			})
		},
		add_template(answer) {
			answer.templates.push({
				"id" : 0,
				"title" : "",
				"com_req" : false,
			});
		},

		remove_answer(idx) {
			console.log("Remove :" + idx);
			this.answers.splice(idx,1);
		},

		remove_template(answer,idx) {
			answer.templates.splice(idx,1);
		},
	},

	computed : {
		answers : {
			get :  function() {
				if(this.question.hasOwnProperty("answers")) {
					return this.question.answers;
				}

				return [];
			},

			set : function(val) {
				this.question.answers = val;
			}
		},
	},


}
</script>

<style scoped>

</style>
